import { useQuery } from "@tanstack/react-query";
import { getBrevoStatus } from "../../api/bBrevoApi";

export const useGetBrevoStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["brevo-status", organisationId],
    queryFn: () => getBrevoStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    onError: (error) => {
      console.error("Error fetching Brevo status:", error.response || error);
    },
  });
};
